import React, { useState, useEffect } from 'react';
import { 
  Image 
} from '@mui/icons-material';

import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function BasicImageButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <Image 
        onClick={onClick}
      />
    );
  } else {
    return (
      <Button
        className={className}
        disabled={disabled} 
        onClick={onClick}
        variant="contained" color="primary">
        <Image/>&nbsp;{ label }
      </Button>
    );
  }
}
